export default __webpack_public_path__ + "static/media/game-type-01.c7332cfb.png";